import { baseProdEnv } from './base.prod';
import { Environments } from './types';

export const environment: Environments = baseProdEnv;
